/**
 * Pawmatix Subscription Widget
 *
 * Reads configuration from data attributes on [data-js-product-subscription]:
 *   data-monthly-period-label   — e.g. "мес"
 *   data-yearly-period-label    — e.g. "год"
 *   data-basic-already-text     — e.g. "Вече е в количката" (shown when max qty reached)
 *   data-section-id             — section ID for scoping
 */
(function () {
  'use strict';

  function initPwSubscription() {
    if (!window.themeCore || !window.themeCore.utils) {
      window.requestAnimationFrame(initPwSubscription);
      return;
    }

    var containers = document.querySelectorAll('[data-js-product-subscription]');

    containers.forEach(function (container) {
      if (container.getAttribute('data-pw-initialized')) return;
      container.setAttribute('data-pw-initialized', 'true');

      // ── Config from data attributes (set via Liquid in the snippet) ──
      var CONFIG = {
        monthlyPeriodLabel: container.getAttribute('data-monthly-period-label') || 'мес',
        yearlyPeriodLabel: container.getAttribute('data-yearly-period-label') || 'год',
        basicAlreadyText: container.getAttribute('data-basic-already-text') || 'Вече е в количката',
      };

      var hiddenInput = container.querySelector('[data-js-selling-plan-input]');
      var form = container.closest('[data-js-product-form]');
      var productJSON = null;
      var themeFormatMoney = window.themeCore.utils.formatMoney;

      if (form) {
        var jsonEl = form.querySelector('[data-js-product-json]');
        if (jsonEl) {
          try {
            productJSON = JSON.parse(jsonEl.textContent);
          } catch (e) {}
        }
      }

      var state = {
        billing: 'yearly',
        plan: null,
        pets: 1,
      };

      // ── Elements ──
      var billingBtns = container.querySelectorAll('.pw-sub__billing-btn');
      var planTabs = container.querySelectorAll('.pw-sub__plan-tab');
      var planBodies = container.querySelectorAll('.pw-sub__plan-body');
      var lockedOverlays = container.querySelectorAll('.pw-sub__monthly-locked');
      var planContent = container.querySelector('.pw-sub__plan-content');
      var switchBtns = container.querySelectorAll('.pw-sub__switch-btn');
      var petBtns = container.querySelectorAll('.pw-sub__pet-btn');
      var ctaBtns = container.querySelectorAll('.pw-sub__cta');

      // Set initial plan from first active tab
      var activeTab = container.querySelector('.pw-sub__plan-tab.is-active');
      if (activeTab) {
        state.plan = activeTab.getAttribute('data-plan-tab');
      }

      // ── Billing Toggle ──
      billingBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          billingBtns.forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          state.billing = btn.getAttribute('data-billing');
          render();
        });
      });

      // ── Plan Tabs ──
      planTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          planTabs.forEach(function (t) {
            t.classList.remove('is-active');
          });
          tab.classList.add('is-active');
          state.plan = tab.getAttribute('data-plan-tab');
          render();
        });
      });

      // ── Pet Selector ──
      petBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          petBtns.forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          state.pets = parseInt(btn.getAttribute('data-pets'), 10);
          updateQuantityInput();
          render();
        });
      });

      // ── Sync pet count → product form quantity input ──
      function getEffectiveQuantity() {
        var firstTab = container.querySelector('.pw-sub__plan-tab');
        var isBasic = firstTab && state.plan === firstTab.getAttribute('data-plan-tab');
        return isBasic ? 1 : state.pets;
      }

      function updateQuantityInput() {
        if (!form) return;
        var qty = getEffectiveQuantity();

        var qtyInput =
          form.querySelector('[data-quantity-input]') || form.querySelector('input[name="quantity"]');

        if (!qtyInput) {
          qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          qtyInput.setAttribute('data-pw-quantity', 'true');
          form.appendChild(qtyInput);
        }

        var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeSetter.call(qtyInput, qty);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // ── Show/hide pet selector based on active plan ──
      var petRow = container.querySelector('.pw-sub__pet-row');
      function updatePetSelectorVisibility() {
        if (!petRow) return;
        var firstTab = container.querySelector('.pw-sub__plan-tab');
        var isBasic = firstTab && state.plan === firstTab.getAttribute('data-plan-tab');
        petRow.style.opacity = isBasic ? '0.35' : '1';
        petRow.style.pointerEvents = isBasic ? 'none' : '';
      }

      // ── Switch to yearly ──
      switchBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var yearlyBtn = container.querySelector('.pw-sub__billing-btn[data-billing="yearly"]');
          billingBtns.forEach(function (b) {
            b.classList.remove('is-active');
          });
          yearlyBtn.classList.add('is-active');
          state.billing = 'yearly';
          render();
        });
      });

      // ── Hide the theme's native add-to-cart button ──
      if (form) {
        var nativeAtcWrap = form.querySelector('.product-add-to-cart');
        if (nativeAtcWrap) {
          nativeAtcWrap.style.display = 'none';
        }
      }

      // ── CTA buttons → set selling plan + submit the form with loading state ──
      var MAX_BASIC_QTY = 1;
      var MAX_SUBSCRIPTION_QTY = 3;

      function submitAddToCart(btn, originalText) {
        if (form) {
          var addToCartBtn =
            form.querySelector('button.add-to-cart') ||
            form.querySelector('button[type="submit"]') ||
            form.querySelector('[name="add"]');
          if (addToCartBtn) {
            addToCartBtn.click();
          }
        }
        setTimeout(function () {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        }, 2500);
      }

      function showAlreadyInCart(btn, originalText) {
        btn.classList.remove('is-loading');
        btn.textContent = CONFIG.basicAlreadyText;
        setTimeout(function () {
          btn.textContent = originalText;
        }, 2000);
      }

      /**
       * Count qty in cart for a specific selling plan ID.
       * For Basic: matches by plan name containing 'basic' (covers monthly + yearly).
       * For others: matches by exact selling plan ID.
       */
      function getCartQtyForPlan(cart, sellingPlanId, basicOnly) {
        var total = 0;
        (cart.items || []).forEach(function (ci) {
          if (!ci.selling_plan_allocation || !ci.selling_plan_allocation.selling_plan) return;
          if (basicOnly) {
            var spName = (ci.selling_plan_allocation.selling_plan.name || '').toLowerCase();
            if (spName.indexOf('basic') !== -1) {
              total += ci.quantity;
            }
          } else {
            if (String(ci.selling_plan_allocation.selling_plan.id) === String(sellingPlanId)) {
              total += ci.quantity;
            }
          }
        });
        return total;
      }

      /**
       * Enforce max qty for a specific plan's items in the cart.
       */
      function enforceCartMaxForPlan(cart, sellingPlanId, maxQty, basicOnly) {
        var promises = [];
        (cart.items || []).forEach(function (ci) {
          if (!ci.selling_plan_allocation || !ci.selling_plan_allocation.selling_plan) return;
          var match = false;
          if (basicOnly) {
            var spName = (ci.selling_plan_allocation.selling_plan.name || '').toLowerCase();
            match = spName.indexOf('basic') !== -1;
          } else {
            match = String(ci.selling_plan_allocation.selling_plan.id) === String(sellingPlanId);
          }
          if (match && ci.quantity > maxQty) {
            promises.push(
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: ci.key, quantity: maxQty })
              })
            );
          }
        });
        return Promise.all(promises);
      }

      ctaBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-loading')) return;

          var activeTabEl = container.querySelector('.pw-sub__plan-tab[data-plan-tab="' + state.plan + '"]');
          var planId;
          if (state.billing === 'monthly') {
            planId =
              activeTabEl.getAttribute('data-selling-plan-id-monthly') ||
              activeTabEl.getAttribute('data-selling-plan-id-yearly');
          } else {
            planId = activeTabEl.getAttribute('data-selling-plan-id-yearly');
          }
          setSellingPlan(planId);

          btn.classList.add('is-loading');
          var originalText = btn.textContent;
          btn.innerHTML = '<span class="pw-sub__spinner"></span>';

          var basic = isBasicPlan();
          var maxQty = basic ? MAX_BASIC_QTY : MAX_SUBSCRIPTION_QTY;
          var wantedQty = getEffectiveQuantity();

          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var currentQty = getCartQtyForPlan(cart, planId, basic);

              // Enforce: cap any existing items for THIS plan that exceed max
              enforceCartMaxForPlan(cart, planId, maxQty, basic);

              // Already at or above max → show "already in cart"
              if (currentQty >= maxQty) {
                showAlreadyInCart(btn, originalText);
                return;
              }

              // Room left but less than wanted → cap the quantity
              var available = maxQty - currentQty;
              if (wantedQty > available) {
                wantedQty = available;
              }

              // Always force-set the quantity before submitting
              // (ensures the form value matches what we intend to add)
              var qtyInput =
                form.querySelector('[data-quantity-input]') || form.querySelector('input[name="quantity"]');
              if (qtyInput) {
                var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
                nativeSetter.call(qtyInput, wantedQty);
                qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
                qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
              }

              // Small delay to let the input change propagate before clicking ATC
              setTimeout(function () {
                submitAddToCart(btn, originalText);
              }, 50);
            })
            .catch(function () {
              submitAddToCart(btn, originalText);
            });
        });
      });

      // ── Helper: get money format ──
      function getMoneyFormat() {
        if (!form) return window.themeCore.objects.shop.money_format;
        var priceContainer = form.querySelector('.js-price');
        var isCurrency = priceContainer && priceContainer.hasAttribute('data-is-currency-enabled');
        return isCurrency
          ? window.themeCore.objects.shop.money_with_currency_format
          : window.themeCore.objects.shop.money_format;
      }

      function getCurrentVariantId() {
        if (!form) return null;
        var input = form.querySelector('input[name="id"]');
        return input ? parseInt(input.value, 10) : null;
      }

      function getVariant(variantId) {
        if (!productJSON) return null;
        return productJSON.variants.find(function (v) {
          return v.id === variantId;
        });
      }

      // ── Set selling plan on the hidden input + update theme price display ──
      function setSellingPlan(sellingPlanId) {
        hiddenInput.value = sellingPlanId || '';
        updateThemePriceDisplay(sellingPlanId);
        updateURL(sellingPlanId);
      }

      function updateThemePriceDisplay(sellingPlanId) {
        if (!form || !themeFormatMoney) return;
        var priceContainers = form.querySelectorAll('.js-price');
        if (!priceContainers.length) return;

        var variantId = getCurrentVariantId();
        var variant = getVariant(variantId);
        if (!variant) return;

        var price = variant.price;
        var compareAtPrice = variant.compare_at_price;

        if (sellingPlanId) {
          var planId = parseInt(sellingPlanId, 10);
          var allocation =
            variant.selling_plan_allocations &&
            variant.selling_plan_allocations.find(function (a) {
              return a.selling_plan_id === planId;
            });

          if (allocation) {
            price = allocation.per_delivery_price;
            compareAtPrice = allocation.compare_at_price;
          }
        }

        var moneyFormat = getMoneyFormat();
        var onSale = compareAtPrice && compareAtPrice > price;

        priceContainers.forEach(function (priceContainer) {
          var productPriceEls = priceContainer.querySelectorAll('[data-product-price]');
          var productPriceOldEls = priceContainer.querySelectorAll('[data-price-old]');

          productPriceEls.forEach(function (el) {
            el.innerHTML = themeFormatMoney(price, moneyFormat);
          });
          productPriceOldEls.forEach(function (el) {
            el.innerHTML = themeFormatMoney(compareAtPrice, moneyFormat);
          });

          if (onSale) {
            priceContainer.classList.add('is-on-sale');
          } else {
            priceContainer.classList.remove('is-on-sale');
          }
        });
      }

      function updateURL(sellingPlanId) {
        var url = new URL(window.location.href);
        if (sellingPlanId) {
          url.searchParams.set('selling_plan', sellingPlanId);
        } else {
          url.searchParams.delete('selling_plan');
        }
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }

      // ── Helper: find allocation for a selling plan ID from product JSON ──
      function getAllocationForPlan(sellingPlanId) {
        if (!productJSON) return null;
        var variantId = getCurrentVariantId();
        var variant = getVariant(variantId);
        if (!variant || !variant.selling_plan_allocations) return null;
        var pid = parseInt(sellingPlanId, 10);
        return (
          variant.selling_plan_allocations.find(function (a) {
            return a.selling_plan_id === pid;
          }) || null
        );
      }

      // ── Helper: format cents to a display string (no currency symbol) ──
      function formatPriceCents(cents) {
        if (themeFormatMoney) {
          var formatted = themeFormatMoney(cents, getMoneyFormat());
          return formatted
            .replace(/[€$£]/g, '')
            .replace(/EUR|BGN|USD|лв/gi, '')
            .trim();
        }
        return (cents / 100).toFixed(2).replace('.', ',');
      }

      // ── Parse [N] tokens from feature text on init ──
      container.querySelectorAll('.pw-sub__feature-text').forEach(function (el) {
        el.setAttribute('data-original-text', el.textContent);
      });

      // ── Update [N] numbers in features based on pet count ──
      function updateFeatureNumbers() {
        var multiplier = isBasicPlan() ? 1 : state.pets;
        container.querySelectorAll('.pw-sub__feature-text').forEach(function (el) {
          var original = el.getAttribute('data-original-text');
          if (!original) return;
          el.textContent = original.replace(/\[(\d+)\]/g, function (match, num) {
            return parseInt(num, 10) * multiplier;
          });
        });
      }

      // ── Get discount percentage for current pet count and plan ──
      function getDiscountPercent(pricingEl) {
        if (state.pets === 2) {
          return parseInt(pricingEl.getAttribute('data-discount-2-pets') || '0', 10);
        } else if (state.pets >= 3) {
          return parseInt(pricingEl.getAttribute('data-discount-3-pets') || '0', 10);
        }
        return 0;
      }

      // ── Check if current plan is Basic (first plan) ──
      function isBasicPlan() {
        var firstTab = container.querySelector('.pw-sub__plan-tab');
        return firstTab && state.plan === firstTab.getAttribute('data-plan-tab');
      }

      // ── Calculate total price: base × pets × (1 - discount%) ──
      function calcTotalPrice(baseCents, pricingEl) {
        if (isBasicPlan() || state.pets === 1) return baseCents;

        var discountPct = getDiscountPercent(pricingEl);
        var discountedPerPet = Math.round(baseCents * (1 - discountPct / 100));
        return discountedPerPet * state.pets;
      }

      // ── Main render ──
      function render() {
        var isMonthly = state.billing === 'monthly';
        var activeTabEl = container.querySelector('.pw-sub__plan-tab[data-plan-tab="' + state.plan + '"]');
        var isYearlyOnly = activeTabEl ? activeTabEl.getAttribute('data-yearly-only') === 'true' : false;
        var showLocked = isMonthly && isYearlyOnly;

        // Show/hide plan bodies
        planBodies.forEach(function (body) {
          var match = body.getAttribute('data-plan-body') === state.plan;
          body.classList.toggle('is-visible', match && !showLocked);
        });

        // Show/hide locked overlays
        lockedOverlays.forEach(function (locked) {
          var match = locked.getAttribute('data-locked') === state.plan;
          locked.classList.toggle('is-visible', match && showLocked);
        });

        // Featured border
        if (planContent) {
          var isFeaturedPlan = activeTabEl && activeTabEl.querySelector('.pw-sub__popular-dot');
          planContent.classList.toggle('is-featured', !!isFeaturedPlan && !showLocked);
        }

        // ── Pet selector: disable for Basic plan ──
        updatePetSelectorVisibility();

        // ── Update form quantity ──
        updateQuantityInput();

        // Resolve the correct selling plan ID based on billing toggle
        var sellingPlanId = null;
        if (!showLocked && activeTabEl) {
          if (isMonthly) {
            sellingPlanId =
              activeTabEl.getAttribute('data-selling-plan-id-monthly') ||
              activeTabEl.getAttribute('data-selling-plan-id-yearly');
          } else {
            sellingPlanId = activeTabEl.getAttribute('data-selling-plan-id-yearly');
          }
          setSellingPlan(sellingPlanId);
        }

        // ── Update the widget's own price display for the active plan ──
        var visibleBody = container.querySelector('.pw-sub__plan-body[data-plan-body="' + state.plan + '"]');
        if (visibleBody && sellingPlanId) {
          var allocation = getAllocationForPlan(sellingPlanId);
          var pricingEl = visibleBody.querySelector('.pw-sub__pricing');
          var priceAmountEl = visibleBody.querySelector('[data-plan-price]');
          var periodEl = visibleBody.querySelector('[data-plan-period]');
          var monthlyPriceEl = visibleBody.querySelector('[data-plan-monthly-price]');

          if (allocation && priceAmountEl && pricingEl) {
            var baseCents = allocation.per_delivery_price;
            var totalCents = calcTotalPrice(baseCents, pricingEl);

            priceAmountEl.textContent = formatPriceCents(totalCents);

            if (isMonthly) {
              periodEl.textContent = '/' + CONFIG.monthlyPeriodLabel;
              if (monthlyPriceEl) monthlyPriceEl.textContent = '';
            } else {
              periodEl.textContent = '/' + CONFIG.yearlyPeriodLabel;
              if (monthlyPriceEl) {
                var monthlyEquiv = Math.round(totalCents / 12);
                monthlyPriceEl.textContent =
                  '€' +
                  formatPriceCents(monthlyEquiv) +
                  '/' + CONFIG.monthlyPeriodLabel;
              }
            }
          }
        }

        // ── Update [N] numbers in feature lists ──
        updateFeatureNumbers();

        // ── Update CTA data attributes to match current selling plan ──
        ctaBtns.forEach(function (btn) {
          if (sellingPlanId) {
            btn.setAttribute('data-selling-plan-id', sellingPlanId);
          }
        });
      }

      // ── EventBus integration for variant changes ──
      if (window.themeCore.EventBus) {
        var formId = form && form.id;
        if (formId) {
          window.themeCore.EventBus.listen('form:' + formId + ':change-variant', function (data) {
            if (!data.currentVariant) return;
            render();
          });
        }
      }

      // ── Init ──
      updateQuantityInput();
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPwSubscription);
  } else {
    initPwSubscription();
  }
})();
